import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../../auth/AuthProvider";
import { AppShell, useTheme } from "senzo-design-system";
import logoFallback from "../../assets/logo.svg";
import { useScrollToTop } from "@/utils/hooks/useScrollToTop";
import { UnauthorizedPage } from "../UnauthorizedPage";

const NAV_LINKS = [
  {
    id: "panoramica",
    label: "Panoramica",
    path: "/",
    icon: "DashboardCircleIcon",
  },
  {
    id: "aziende",
    label: "Aziende",
    path: "/aziende",
    icon: "City01Icon",
  },
  // {
  //   id: "referenti",
  //   label: "Referenti",
  //   path: "/referenti",
  //   icon: "UserGroupIcon",
  // },
  {
    id: "contenuti",
    label: "Contenuti",
    path: "/contenuti",
    icon: "AlignBoxMiddleCenterIcon",
  },
  {
    id: "screening",
    label: "Screening",
    path: "/screening",
    icon: "Task01Icon",
  },
  // {
  //   id: "contenuti",
  //   label: "Contenuti",
  //   path: "/contenuti",
  //   icon: "AlignBoxMiddleCenterIcon",
  // },
  // {
  //   id: "export",
  //   label: "Export",
  //   path: "/export",
  //   icon: "Download01Icon",
  // },
  {
    id: "statistiche",
    label: "Statistiche",
    path: "/statistiche",
    icon: "LaptopPerformanceIcon",
  },
  {
    id: "supporto",
    label: "Supporto",
    path: "/supporto",
    icon: "CustomerServiceIcon",
  },
  // {
  //   id: "statistiche",
  //   label: "Statistiche",
  //   path: "/statistiche",
  //   icon: "LaptopPerformanceIcon",
  // },
  // {
  //   id: "impostazioni",
  //   label: "Impostazioni",
  //   path: "/impostazioni",
  //   icon: "Settings02Icon",
  // },
];

const USER_MENU_LINKS = [
  {
    id: "profilo",
    label: "Profilo",
    path: "/profilo",
    icon: "Settings02Icon",
  },
  { id: "supporto", label: "Supporto", path: "/supporto", icon: "HeadsetIcon" },
  { id: "logout", label: "Esci", path: "", icon: "LogoutSquare01Icon" },
];

export function MainLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const { parsedToken, logout } = useAuth();
  const { logoUrl } = useTheme();
  const { chatId } = useParams();
  const isChatPage = !!chatId;
  useScrollToTop();

  const ALL_LINKS = [...NAV_LINKS, ...USER_MENU_LINKS];

  const activeLink = ALL_LINKS.find((item) => {
    if (location.pathname === item.path) return true;
    return (
      item.path !== "" &&
      item.path !== "/" &&
      location.pathname.startsWith(item.path + "/")
    );
  });

  if (parsedToken && parsedToken.senzo_role !== "SUPER_ADMIN") {
    return (
      <UnauthorizedPage onLogout={logout}></UnauthorizedPage>
    );
  }

  return (
    <AppShell
      showFooter={!isChatPage}
      sidebar={{
        logo_url: logoUrl ?? logoFallback,
        title: "Senzo Admin",
        mainNavigation: NAV_LINKS.map((item) => ({
          ...item,
          onClick: () => navigate(item.path),
        })),
        activeItemId: activeLink?.id,
        // customSections: adminSection,
      }}
      topbar={{
        iconName: activeLink?.icon ?? "File02Icon",
        pageTitle: activeLink?.label ?? "Senzo",
        userName: parsedToken?.name ?? "Admin",
        userEmail: parsedToken?.email ?? "",
        userMenuLinks: USER_MENU_LINKS,
        onUserMenuNavigate: (path) => (path ? navigate(path) : logout()),
      }}
    >
      <Outlet />
    </AppShell>
  );
}
